import { get, put, post } from "../httpmethods";
import { URL_API } from "../config";


export const StatusAPI = {
    getConfigStatus: async () => {
        return await get(`${URL_API}/config/status`);
    },
    updateStatus: async (id, data) => {
        return await put(`${URL_API}/config/status/${id}`, data);
    },
    createStatus: async (data) => {
        return await post(`${URL_API}/config/status`, data);
    },
    saveAllStatus: async (statusList) => {
        return await put(`${URL_API}/config/status`, { status: statusList });
    },
}
